export default {
  data() {
    return {
      focus: false
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    error: {
      type: String
    },
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    value: {
      required: true,
      default: ''
    },
    labelClass: {
      type: String
    },
    inputClass: {
      type: String
    }
  },
  methods: {
    input(e) {
      this.$emit('input', e.target.value);
    }
  }
}